import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Card, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import type { DailyDashboardIssue } from '../../../backendsdk/api';
import { TrackedLink as Link } from '../../../components/TrackedComponents';
import { FleetDriversView } from './Defs';

interface WellnessIssueCardProps {
    item: DailyDashboardIssue;
    cardId: number;
    viewMode: FleetDriversView;
}

const WellnessIssueCard: React.FC<WellnessIssueCardProps> = (props) => {
    const isOdd = props.cardId % 2 == 1;
    const details = props.item.issue_details;

    const getUrl = (details: DailyDashboardIssue['issue_details']) => {
        if (details.event_id) {
            return `/events/${details.event_id}`;
        }
        const path = details.task_id ? `/tasks/${details.task_id}` : '/tasks';
        const taskType = details.task_type;
        if (!!taskType) {
            const params = new URLSearchParams({ task_type: String(taskType) });
            return `${path}?${params.toString()}`;
        }
        return path;
    };

    const url = getUrl(details);

    const wellnessLink = (
        <>
            <Link id="wellness-link" component={RouterLink} to={url}>
                here
            </Link>
            <IconButton
                component={RouterLink}
                to={url}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                aria-label="Open in new tab"
            >
                <OpenInNewIcon sx={{ mb: 0.7, fontSize: 12 }} />
            </IconButton>
        </>
    );

    return (
        <Card
            sx={{
                my: 1,
                p: 2,
                width: 'clamp(40%, 700px, 80%)',
                backgroundColor: isOdd ? '#e0e0e0' : '#cdcdcd',
                borderRadius: '5px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 1,
                }}
            >
                <Box>
                    <Typography variant="caption" sx={{ color: '#606060', fontSize: '12px' }}>
                        Issue #{props.cardId}
                    </Typography>
                    {props.item.issue_details.issue.map((desc: string, idx: number) => (
                        <Typography variant="subtitle1" key={idx} sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                            {desc}
                        </Typography>
                    ))}
                    {props.item.issue_details.remediation.map((desc: string, idx: number) => {
                        const hasWellnessLink = desc.includes('<WELLNESS_LINK>');
                        const parts = hasWellnessLink ? desc.split('<WELLNESS_LINK>') : [desc];
                        const content = hasWellnessLink
                            ? parts.flatMap((part, i) => (i < parts.length - 1 ? [part, wellnessLink] : [part]))
                            : [desc];
                        return (
                            <Typography variant="subtitle1" key={idx} sx={{ fontSize: '18px' }}>
                                {content.map((node, i) =>
                                    typeof node === 'string' ? node : <React.Fragment key={i}>{node}</React.Fragment>,
                                )}
                            </Typography>
                        );
                    })}
                </Box>
            </Box>
        </Card>
    );
};

export default WellnessIssueCard;
